import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import JisButton from "../../components/controls/jisButton";
import JisTable from "../../components/controls/jisTable";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import JisTabButton from "../../components/controls/jisTabButton";
import BackLoader from "../../components/backloader";
import JisAlert from "../../components/jisalert";
import { Link, useNavigate, useParams } from "react-router-dom";
import Pagenated from "../../components/pagenated";
import JisCheckbox from "../../components/controls/jisCheckbox";
import JisPrompt from "../../components/jisprompt";

// NIN / Payer ID / business registration only apply to external filing accounts
// (Legal Counsel, or the Legal / Non-Legal filing roles) - not to internal staff
// such as Judges, PSA, CFO, ACR, Admin...
const needsPayerDetails = (u) =>
  !!u?.isLegalCounsel ||
  [Constants.Legal_Role_id, Constants.Non_Legal_Role_id].includes(Number(u?.roleId));


function ManageUsers() {
  const pagecode = "manageusers";
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({ roleId: null, isOrg: false });
  const [search, setSearch] = useState({});
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(30);
  const [totalcount, setTotalCount] = useState(0);
  const [states, setStates] = useState([]);
  const [Lga, setLga] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [payidgen, setPayidgen] = useState(false);
  const [isNin, setIsNin] = useState(true);
  const [isPass, setIsPass] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [page, setPage] = useState(null);
  const [tab, setTab] = useState("users");
  const [isPreview, setIsPreview] = useState(false);
  const [aIndex, setAIndex] = useState(-1);
  const [isSearch, setIsSearch] = useState(false);
  const [err, setErr] = useState("");
  const [courts, setCourts] = useState([]);
  const [judgeTypes, setJudgeTypes] = useState([]);
  const [parents, setParents] = useState([]);
  const [statusTarget, setStatusTarget] = useState(null); // user awaiting activate/deactivate confirmation
  const [statusResult, setStatusResult] = useState(null); // { title, subtitle, icon } after the call

  const loadPage = async () => {
    const data = await Constants.onScreenDetails(pagecode, token);
    setPage(data);
  };

  useEffect(() => {
    loadPage();
    onLoad();
    onLoadProfiles();
  }, []);

  useEffect(() => {
    if (!isSearch) {
      onLoadProfiles();
    } else {
      onSearch(search);
    }
  }, [pageIndex, pageSize]);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/profile/roles`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setRoles(data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadProfiles = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/profiles/${pageIndex}/${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      if (data.code == 0) {
        setUsers(data.items);
        if (data.totalCount > 0) {
          setTotalCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onSearch = async (sear) => {
    setIsSearch(true);
    console.log(sear);

    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/profile/profiles/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setUsers(data.items);
        if (data.totalCount > 0) {
          setTotalCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const gender = [
    { label: "Male", value: "M" },
    { label: "Female", value: "F" },
  ];
  useEffect(() => {
    onGetStates();
    //get latest 20 records from db in addition
  }, []);
  useEffect(() => {
    if (user.isJudge && user.divisionId != null) {
      //load the court in the division
      onGetCourts();
    }
  }, [user.divisionId, user.isJudge]);

  useEffect(() => {
    if (user.state) {
      onGetLgs(user.state);
    }
  }, [user.state]);

  useEffect(() => {
    if (user.lga) {
      onGetCities(user.lga);
    }
  }, [user.lga]);

  const onGetStates = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/profile/states`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setStates(data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (user.id != null && user.id > 0 && user.isJudge) {
      onGetJudge();
    }
  }, [user.id]);

  useEffect(() => {
    //first check if the role has active
    console.log(`for user with ${user.roleId}, ${user.divisionId}`);
    var role = roles.find((e) => e.id == user.roleId);
    console.log(role);
    if (role == null || role.parentRoleId == 0) {
      console.log("inside null");
      setParents([]);
      return;
    }

    if (user.roleId != null && user.divisionId != null) {
      onGetUserByRole(role.parentRoleId, user.divisionId);
    }
  }, [user.roleId, user.divisionId]);

  const onGetJudge = async () => {
    //for account registration
    if (user.id == null || user.id == 0) {
      return;
    }
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getjudgedetails/${user.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      var judge = data.judge;
      if (judge != null) {
        console.log(
          `setting value for courtid: ${judge.courtId} and ${judge.judgeTypeId}`,
        );
        console.log(judge);
        setUser({
          ...user,
          courtId: judge.courtId,
          judgeTypeId: judge.judgeTypeId,
        });
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onGetCourts = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getcourts/${user.divisionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setCourts(data.courts);
      setJudgeTypes(data.types);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onGetLgs = async (stateid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/profile/lgs/${stateid}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLga(data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onGetCities = async (lgid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/profile/cities/${lgid}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setCities(data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onGetUserByRole = async (roleid, divisionid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getUsersByRole/${roleid}/${divisionid}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: "" },
        },
      );
      const data = await resp.json();
      setParents(data.pros);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onUserChange = (e) => {
    var _user = { ...user, [e.target.name]: e.target.value };

    if (e.target.name == "userType") {
      const f = e.target.value;
      if (f == "0") {
        _user.isOrg = false;
      } else {
        _user.isOrg = true;
      }
    }

    setUser(_user);
  };

  const onSearchChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };

  const onSave = async (e) => {
    e.preventDefault();
    setErr("");

    //clear the parentId if the role is not doing such
    var _user = user;
    var role = roles.find((e) => e.id == user.roleId);
    if (role == null || role.parentRoleId == 0) {
      _user.parentId = null;
    }
    setLoading(true);
    try {
      const url =
        user.id == 0
          ? `${Constants.apiUrl}/profile/newprofile`
          : `${Constants.apiUrl}/profile/update-profile/${user.id}`;
      const resp = await fetch(url, {
        method: "POST",
        body: JSON.stringify(_user),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setIsSuccess(true);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setErr(data.status);
      }
      //   setFlow({pos:6,code:"congrat"})
    } catch (error) {
      setLoading(false);
      console.error(error);

      // onMove();
    }
  };
  // Admin: activate / deactivate an account
  const isUserActive = (u) => u?.isActive !== false; // null/undefined treated as active

  const onAskStatusChange = (item) => {
    setStatusTarget(item);
  };

  const onConfirmStatusChange = async () => {
    const target = statusTarget;
    setStatusTarget(null);
    if (!target) return;

    const newStatus = !isUserActive(target);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/profile/set-status/${target.id}`,
        {
          method: "POST",
          body: JSON.stringify({ isActive: newStatus }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);

      if (data.code == 0) {
        // update the row (and the open profile, if it is the same user)
        setUsers((prev) =>
          prev.map((u) =>
            u.id === target.id ? { ...u, isActive: data.isActive } : u,
          ),
        );
        setUser((prev) =>
          prev?.id === target.id ? { ...prev, isActive: data.isActive } : prev,
        );
        setStatusResult({
          title: data.isActive ? "Account Activated" : "Account Deactivated",
          subtitle: data.isActive
            ? `${target.firstName ?? ""} ${target.lastName ?? ""} (${target.userName}) can now log in.`
            : `${target.firstName ?? ""} ${target.lastName ?? ""} (${target.userName}) can no longer log in.`,
          icon: "done",
        });
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setStatusResult({
          title: "Unable to change status",
          subtitle: data.status || Constants.serverErr,
          icon: "close",
        });
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setStatusResult({
        title: "Unable to change status",
        subtitle: Constants.serverErr,
        icon: "close",
      });
    }
  };

  const onNewUser = () => {
    setAIndex(-1);
    setIsPreview(true);
    setUser({ id: 0, roleId: null, isOrg: false });
  };

  const onView = (it, ind) => {
    setIsPreview(true);
    setUser(it);
    setAIndex(ind);
  };

  const onSuccessRegister = () => {
    setIsSuccess(false);
    setIsPreview(false);
    setAIndex(-1);
    setUser({ id: 0, roleId: null, isOrg: false });
  };

  const closePreview = () => {
    setIsPreview(false);
    setAIndex(-1);
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  return (
    <div style={{ padding: "20px" }}>
      <div>
        <div>
          <div style={{ flex: 1 }}>
            <div style={{ textAlign: "right" }}>
              <JisButton onClick={onNewUser}>New User</JisButton>
            </div>
            <div className="panel">
              <div className="title"> User search</div>
              <div className="panel-body">
                <div style={{ display: "flex" }}>
                  <div className="input-group">
                    <label> First Name</label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="person_3" />
                      <input
                        placeholder="First Name"
                        name="firstname"
                        value={search.firstname}
                        onChange={onSearchChange}
                      />
                    </div>
                  </div>
                  <div className="input-group">
                    <label> Last Name</label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="person_3" />
                      <input
                        placeholder="Last Name"
                        name="lastname"
                        value={search.lastname}
                        onChange={onSearchChange}
                      />
                    </div>
                  </div>
                  <div className="input-group">
                    <label> User Name</label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="person_3" />
                      <input
                        placeholder="User Name"
                        name="username"
                        value={search.username}
                        onChange={onSearchChange}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div className="select-group">
                    <label>Role</label>
                    <select
                      name="roleid"
                      value={search.roleid}
                      onChange={onSearchChange}
                    >
                      <option value="">Select </option>
                      {roles.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>Division</label>
                    <select
                      name="divisionid"
                      value={search.divisionid}
                      onChange={onSearchChange}
                    >
                      <option value="">Select </option>
                      {frequentData.divisions?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="panel-btn">
                <JisButton onClick={() => onSearch(search)}>Search</JisButton>
              </div>
            </div>

            <div className="table">
              <div class="section-cases">
                <span>Users</span>
              </div>
              <table class="case-table">
                <thead>
                  <tr>
                    {/* <th className="col-id">ID</th> */}

                    <th className="col-id">SN</th>
                    <th className="col-title"> Name</th>
                    <th className="col-title">User Name</th>
                    <th className="col-medium">Role</th>
                    <th className="col-medium">Division</th>
                    <th className="col-title">Legal Counsel</th>
                    <th className="col-medium">Created On</th>
                    <th className="col-medium">Status</th>
                    <th className="col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        className={`${aIndex == index ? "active" : ""}`}
                      >
                        <td>{index + pageSize * pageIndex + 1}</td>
                        <td>
                          {item.firstName} {item.lastName ?? ""}
                        </td>
                        <td>{item.userName}</td>
                        <td>
                          {Constants.getItemById(roles, item.roleId)?.name}
                        </td>
                        <td>
                          {" "}
                          {
                            Constants.getItemById(
                              frequentData.divisions,
                              item.divisionId,
                            )?.title
                          }{" "}
                        </td>
                        <td>{item.isLegalCounsel ? "Yes" : "No"}</td>
                        <td>
                          {" "}
                          {Constants.momentDate(item.createdOn)?.format(
                            "DD MMM, YYYY",
                          )}
                        </td>
                        <td>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "2px 10px",
                              borderRadius: 12,
                              fontSize: 12,
                              fontWeight: 600,
                              color: isUserActive(item) ? "#1b5e20" : "#b71c1c",
                              background: isUserActive(item)
                                ? "#e8f5e9"
                                : "#ffebee",
                            }}
                          >
                            {isUserActive(item) ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <JisButton onClick={() => onView(item, index)}>
                            {" "}
                            View Profile{" "}
                          </JisButton>{" "}
                          {item.id !== profile?.id && (
                            <JisButton
                              variant="outline"
                              icon={isUserActive(item) ? "block" : "check_circle"}
                              onClick={() => onAskStatusChange(item)}
                            >
                              {isUserActive(item) ? "Deactivate" : "Activate"}
                            </JisButton>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {users?.length > 0 && (
                <Pagenated
                  onChangePageSize={(k) => setPageSize(k)}
                  size={pageSize}
                  total={totalcount}
                  maxPage={20}
                  onPick={onPagePick}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {loading && <BackLoader />}
      {isPreview && (
        <div className={"preview open"} style={{ overflow: "scroll" }}>
          <div className="heading">
            <div className="buttongroup">
              <JisButton icon="close" onClick={closePreview}>
                {" "}
                Close User
              </JisButton>
            </div>
            <div className="panel">
              <div className="title">User</div>
              <div className="panel-body">
                <form onSubmit={onSave}>
                  <div style={{ flex: 1 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex" }}>
                        <div className="select-group">
                          <label>Role</label>
                          <select
                            name="roleId"
                            value={user.roleId}
                            required
                            onChange={onUserChange}
                          >
                            <option value="">Select </option>
                            {roles.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="select-group">
                          <label>Division</label>
                          <select
                            name="divisionId"
                            value={user.divisionId}
                            onChange={onUserChange}
                          >
                            <option value="">Select </option>
                            {frequentData.divisions?.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.title}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="select-group">
                          <label>
                            Account Type <span className="required">*</span>
                          </label>
                          <select
                            name="userType"
                            value={user.isOrg ? "1" : "0"}
                            required
                            onChange={onUserChange}
                          >
                            <option value="0">Individual</option>
                            <option value="1">Organisation</option>
                          </select>
                        </div>
                        {!user.isOrg && (
                        <div className="select-group">
                          <label>
                            {" "}
                            Title <span className="required">*</span>
                          </label>
                          <select
                            name="suffix"
                            value={user.suffix}
                            onChange={onUserChange}
                            required
                          >
                            <option value="">Select Title</option>
                            <option value="Mr">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="Miss">Miss</option>
                            <option value="Dr">Dr</option>
                            <option value="Dr(Mrs)">Dr(Mrs)</option>
                            <option value="Chief">Chief</option>
                            <option value="Chief(Mrs)">Chief(Mrs)</option>
                            <option value="Engr">Engr</option>
                            <option value="Engr(Mrs)">Engr(Mrs)</option>
                            <option value="Alhaji">Alhaji</option>
                            <option value="Alhaja">Alhaja</option>
                            <option value="Rev">Rev</option>
                            <option value="Pastor">Pastor</option>
                            <option value="Admiral">Admiral</option>
                            <option value="General">General</option>
                            <option value="Air Comm.">Air Comm.</option>
                            <option value="Captain">Captain</option>
                            <option value="Lt. Col">Lt. Col</option>
                            <option value="Rev(Mrs)">Rev(Mrs)</option>
                            <option value="Bishop">Bishop</option>
                            <option value="Arch Bishop">Arch Bishop</option>
                            <option value="Primate">Primate</option>
                            <option value="Architect">Architect</option>
                            <option value="Hon. Justice">
                              Honorable Justice
                            </option>
                          </select>
                        </div>
                        )}
                      </div>

                      {user.isOrg ? (
                        <div className="input-group">
                          <label>
                            Organisation Name <span className="required">*</span>
                          </label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="person_3" />
                            <input
                              placeholder="Organisation Name"
                              required={true}
                              name="firstName"
                              value={user.firstName ?? ""}
                              onChange={onUserChange}
                            />
                          </div>
                        </div>
                      ) : (
                      <div>
                        <div>
                          <div className="input-group">
                            <label>
                              Surname/Last name{" "}
                              <span className="required">*</span>
                            </label>
                            <div className="input-wrapper">
                              <DynamicIcon iname="person_3" />
                              <input
                                name="lastName"
                                required={true}
                                value={user.lastName}
                                onChange={onUserChange}
                                placeholder="surname/lastname"
                              />
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div className="input-group">
                            <label>
                              {" "}
                              First Name <span className="required">*</span>
                            </label>
                            <div className="input-wrapper">
                              <DynamicIcon iname="person_3" />
                              <input
                                label=""
                                placeholder="Firstname"
                                required={true}
                                name="firstName"
                                value={user.firstName}
                                onChange={onUserChange}
                              />
                            </div>
                          </div>

                          <div className="input-group">
                            <label> Middle Name</label>
                            <div className="input-wrapper">
                              <DynamicIcon iname="person_3" />
                              <input
                                label=""
                                placeholder="Middle Name"
                                name="middleName"
                                value={user.middleName}
                                onChange={onUserChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      )}

                      <div className="input-group">
                        <label>
                          Address <span className="required">*</span>
                        </label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="add_home" />
                          <input
                            placeholder="address1"
                            name="address1"
                            required={true}
                            value={user.address1}
                            onChange={onUserChange}
                          />
                        </div>
                      </div>

                      {!user.isOrg && (
                        <div style={{ display: "flex" }}>
                          <div className="input-group">
                            <label>
                              {" "}
                              Date of Birth <span className="required">*</span>
                            </label>
                            <div className="input-wrapper">
                              <DynamicIcon iname="calendar-days" />
                              <input
                                placeholder="Date of Birth"
                                type="date"
                                required
                                name="dateOfBirth"
                                value={user.dateOfBirth}
                                onChange={onUserChange}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {!user.isOrg && (
                        <div style={{ display: "flex" }}>
                          <div className="select-group">
                            <label>
                              Gender <span className="required">*</span>
                            </label>
                            <select
                              name="sex"
                              value={user.sex}
                              required={true}
                              onChange={onUserChange}
                            >
                              <option value="">Select gender</option>
                              {gender.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="select-group">
                            <label> Marital Status</label>

                            <select
                              name="maritalStatus"
                              value={user.maritalStatus}
                              onChange={onUserChange}
                              required={true}
                            >
                              <option value="">Select marital Status</option>
                              <option value="M">Married</option>
                              <option value="S">Single</option>
                              <option value="W">Widow/Widower</option>
                              <option value="D">Divorced</option>
                            </select>
                          </div>
                        </div>
                      )}

                      <div style={{ display: "flex" }}>
                        <div className="input-group">
                          <label>
                            {" "}
                            Primary Email <span className="required">*</span>
                          </label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="email" />
                            <input
                              name="primaryEmail"
                              type="email"
                              required
                              value={user.primaryEmail}
                              onChange={onUserChange}
                              placeholder="Email"
                            />
                          </div>
                        </div>
                        <div className="input-group">
                          <label>
                            {" "}
                            Primary Phone <span className="required">*</span>
                          </label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="phone_in_talk" />
                            <input
                              placeholder="primaryphone"
                              name="primaryContactNumber"
                              required={true}
                              value={user.primaryContactNumber}
                              onChange={onUserChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div style={{ display: "flex" }}>
                        <div className="select-group">
                          <label>
                            {" "}
                            State <span className="required">*</span>
                          </label>
                          <select
                            name="state"
                            required={true}
                            value={user.state}
                            onChange={onUserChange}
                            options={gender}
                          >
                            <option value="">Select state</option>
                            {states.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.title}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="select-group">
                          <label>
                            {" "}
                            L.G.A <span className="required">*</span>
                          </label>
                          <select
                            name="lga"
                            value={user.lga}
                            required={true}
                            onChange={onUserChange}
                          >
                            <option value="">Select LG</option>
                            {Lga.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.title}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="select-group">
                          <label>
                            {" "}
                            City <span className="required">*</span>
                          </label>
                          <select
                            name="city"
                            value={user.city}
                            required={true}
                            onChange={onUserChange}
                          >
                            <option value="">City</option>
                            {cities.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {parents.length > 0 && (
                        <div className="select-group">
                          <label>Parent User</label>
                          <select
                            name="parentId"
                            value={user.parentId}
                            onChange={onUserChange}
                          >
                            <option value="">Select </option>
                            {parents.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.suffix} {opt.firstName}{" "}
                                {opt.lastName ?? ""}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      <div style={{ display: "flex" }}>
                        <JisCheckbox
                          label="Check if This Account is Legal Counsel"
                          value={user.isLegalCounsel}
                          onChange={(e) =>
                            setUser({ ...user, isLegalCounsel: e })
                          }
                        />
                        <JisCheckbox
                          label="Check if This Account is Government Account"
                          value={user.isMinistryOfJustice}
                          onChange={(e) =>
                            setUser({ ...user, isMinistryOfJustice: e })
                          }
                        />
                      </div>
                      {user.isLegalCounsel && (
                        <div>
                          <div className="input-group">
                            <label>
                              {" "}
                              Bar Number<span className="required">*</span>
                            </label>
                            <div className="input-wrapper">
                              <DynamicIcon iname="phone_in_talk" />
                              <input
                                placeholder="Bar number"
                                name="barNumber"
                                required={true}
                                value={user.barNumber}
                                onChange={onUserChange}
                              />
                            </div>
                          </div>
                          <note>
                            Legal counsel is required to provide Call to bar
                            number
                          </note>
                        </div>
                      )}
                      {needsPayerDetails(user) && (
                      <div className="input-group">
                        <label> Payer ID</label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="card" />
                          <input
                            placeholder={`${user.isOrg ? "C" : "N"}-123456`}
                            name="payerId"
                            pattern="^(N|C)-\d{1,12}$"
                            value={user.payerId}
                            title="Must start with N- or C- followed by 4 to 12 digits"
                            onChange={onUserChange}
                            max={15}
                          />
                        </div>
                      </div>
                      )}
                    </div>
                    <div style={{ display: "flex" }}>
                      <JisCheckbox
                        label="Check if This Account is a Judge"
                        value={user.isJudge}
                        onChange={(e) => setUser({ ...user, isJudge: e })}
                      />
                      {user.isJudge && (
                        <>
                          <div className="select-group">
                            <label>
                              {" "}
                              Court <span className="required">*</span>
                            </label>
                            <select
                              name="courtId"
                              value={user.courtId}
                              required={true}
                              onChange={onUserChange}
                            >
                              <option value="">Select Court</option>
                              {courts.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                  {opt.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="select-group">
                            <label>
                              Judge Type <span className="required">*</span>
                            </label>
                            <select
                              name="judgeTypeId"
                              value={user.judgeTypeId}
                              required={true}
                              onChange={onUserChange}
                            >
                              <option value="">Select Judge Type </option>
                              {judgeTypes?.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                  {opt.title}
                                </option>
                              ))}
                            </select>
                          </div>{" "}
                        </>
                      )}
                    </div>

                    <div>
                      <h2>Access Information</h2>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ flex: 1 }}>
                          <div>
                            <div className="input-group">
                              <label>
                                {" "}
                                Username <span className="required">*</span>
                              </label>
                              <div className="input-wrapper">
                                <DynamicIcon iname="person_3" />
                                <input
                                  placeholder="username"
                                  name="userName"
                                  value={user.userName}
                                  onChange={onUserChange}
                                  required
                                  disabled={user.id > 0}
                                />
                              </div>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div className="input-group">
                              <label>
                                Password <span className="required">*</span>
                              </label>
                              <div className="input-wrapper">
                                <DynamicIcon iname="lock" />
                                <input
                                  placeholder="password"
                                  type={`${isPass ? "password" : "text"}`}
                                  name="password"
                                  value={user.password}
                                  onChange={onUserChange}
                                  required={user.id == 0 ? true : false}
                                />
                                <DynamicIcon
                                  iname={`${isPass ? "visibility" : "visibility_off"}`}
                                  onClick={() => setIsPass(!isPass)}
                                />
                              </div>
                            </div>
                            <div className="input-group">
                              <label>
                                {" "}
                                Confirm Password{" "}
                                <span className="required">*</span>
                              </label>
                              <div className="input-wrapper">
                                <DynamicIcon iname="lock" />
                                <input
                                  placeholder="confirmpassword "
                                  name="confirmpassword"
                                  type={`${isPass ? "password" : "text"}`}
                                  value={user.confirmpassword}
                                  onChange={onUserChange}
                                  required={user.id == 0 ? true : false}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {err != "" && <div className="error">{err}</div>}
                  <div>
                    <JisButton type="submit"> Save</JisButton>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <JisPrompt
        open={statusTarget != null}
        title={isUserActive(statusTarget) ? "Deactivate Account" : "Activate Account"}
        onOk={onConfirmStatusChange}
        onCancel={() => setStatusTarget(null)}
      >
        <p>
          {isUserActive(statusTarget)
            ? "Deactivate the account of "
            : "Activate the account of "}
          <b>
            {statusTarget?.firstName} {statusTarget?.lastName ?? ""} (
            {statusTarget?.userName})
          </b>
          ?{" "}
          {isUserActive(statusTarget)
            ? "The user will no longer be able to log in."
            : "The user will be able to log in again."}
        </p>
      </JisPrompt>

      {statusResult && (
        <JisAlert
          title={statusResult.title}
          subtitle={statusResult.subtitle}
          icon={statusResult.icon}
          actiontext="Ok"
          onOk={() => setStatusResult(null)}
        />
      )}

      {isSuccess && (
        <JisAlert
          title="Successful"
          subtitle="Account created Successfully"
          onOk={onSuccessRegister}
          actiontext="Ok"
          icon="done"
        />
      )}
    </div>
  );
}

export default ManageUsers;
